<template>
  <div id="bullClass">
      <v-header  :selectedItemVal="3" ref="header"></v-header>
	  
	  <div class="main">
		  <div class="bullClass">
			  <div class="page_tag">
			  	<h2>
			  		首页 &nbsp;> &nbsp; 牛人课
			  	</h2>
			  </div>
			  <div class="page_content">
				  <v-classList :bullClassData="bullClassList"></v-classList>
			  </div>
			  <div class="paginate">
				  <el-pagination
				    background
				    :layout="paginate.layout"
				    :page-count="paginate.pageCount" 
					:hide-on-single-page="paginate.singleHidePage"
					@current-change="current_change">
				  </el-pagination>
			  </div>
		  </div>
	  </div>
	  
	  <v-footer></v-footer>
  </div>
</template>

<script>
import vHeader from '../common/header'

import vClassList from '../common/class_list'

import vFooter from '../common/footer'

export default {
	name:'bullClass',
	data(){
		return {
			bullClassList:[],
			paginate:{
				// "total":12,
				"pageCount":0,
				"layout":"prev, pager, next",
				"currentPage":1,
				"singleHidePage":true,
			},
		};
	},
	props:{
		bullClassData:{
			type:Array,
		}
	},
	created() {
		// this.$message({
		// 	type:'info',
		// 	message:'暂未开放',
		// 	duration:500
		// });
		// this.$router.go(-1);
	},
	mounted() {
		this.getBullClassList();
	},
	components: {
      'v-header': vHeader,
	  'v-footer':vFooter,
	  'v-classList':vClassList
    },
	methods:{
		//获取牛人课
		getBullClassList(){
			//+-----------------构建请求参数----------------------
			let data = {
				page:this.paginate.currentPage,
			};
			//+-----------------获取牛人课列表---------------------
			this.apiServer.bullClass.getListByWeb(this.qs.stringify(data))
			.then(res => {
				if(res.data.code == 200){
					//更新牛人课列表数据
					this.bullClassList = res.data.data.videos;
					//更新列表总页数
					this.paginate.pageCount = res.data.data.totalPage;
				}
			})
			.catch(res => {
				this.$message.error('获取牛人课列表异常');
			});
		},
		//列表页码改变事件
		current_change:function(currentPage){
			this.paginate.currentPage = currentPage;
			
			//+---------------请求新页码牛人课数据--------------------
			this.getBullClassList();
		},
	},
}
</script>

<style scoped>	
	.bullClass{
		width: 1180px;
		margin: 0 auto;
	}
	.paginate{
		text-align: right;
	}
</style>


// WEBPACK FOOTER //
// src/components/bull_class/bullClass.vue